/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Removed_SuccessfullyInputs */

const en_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share was successfully removed`)
};

const fr_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le partage a été supprimé avec succès`)
};

const de_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Freigabe wurde erfolgreich entfernt.`)
};

const it_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La condivisione è stata rimossa con successo`)
};

const ru_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доля была успешно удалена.`)
};

const es_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El recurso compartido se eliminó correctamente`)
};

const zh_cn2_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享已成功移除`)
};

const ja_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有が正常に削除されました`)
};

const hi_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_team_share_removed_successfully = /** @type {(inputs: Team_Share_Removed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partilha foi removida com sucesso.`)
};

/**
* | output |
* | --- |
* | "Share was successfully removed" |
*
* @param {Team_Share_Removed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_removed_successfully = /** @type {((inputs?: Team_Share_Removed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Removed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_removed_successfully(inputs)
	if (locale === "de") return de_team_share_removed_successfully(inputs)
	if (locale === "it") return it_team_share_removed_successfully(inputs)
	if (locale === "ru") return ru_team_share_removed_successfully(inputs)
	if (locale === "es") return es_team_share_removed_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_removed_successfully(inputs)
	if (locale === "ja") return ja_team_share_removed_successfully(inputs)
	if (locale === "hi") return hi_team_share_removed_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_removed_successfully(inputs)
	return en_team_share_removed_successfully(inputs)
});